// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  TileSelect,
  TilesBundleColumn,
} from '../tileSelect';
import { getBundles } from '../../../../store/configuration/actives';
import {
  getActiveBundleId,
  toggleBundle,
} from '../../../../store/configuration';
import type { Bundle as BundleType } from '../../../../types/pdb';
import type { FixMe } from '../../../../types/any';

type OwnProps = {|
  pdbId?: string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  bundles: Array<BundleType>,
  activeBundle: ?number,
|};

type DispatchProps = {|
  setBundle: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const Bundle = ({ bundles, activeBundle, setBundle }: Props) => (
  <TileSelect data-cy="bundleTileSelect">
    <TilesBundleColumn
      blocks={bundles}
      activeBlock={activeBundle}
      setBlock={setBundle}
    />
    <TilesBundleColumn
      blocks={bundles}
      activeBlock={activeBundle}
      setBlock={setBundle}
    />
  </TileSelect>
);

Bundle.defaultProps = {
  pdbId: '',
};

// @TODO Cannot return function because function [1] is not an object.
const makeMapStateToProps = (): FixMe => (state): StateProps => ({
  bundles: getBundles(state),
  activeBundle: getActiveBundleId(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  setBundle: (id: number) => dispatch(toggleBundle(id)),
});

Bundle.defaultProps = {
  pdbId: '',
};

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  makeMapStateToProps,
  mapDispatchToProps,
)(Bundle);
